export enum PassengerDetails {
  NOBAG = "NOBAG"
}

export type PassengerDetailsEnumType = keyof typeof PassengerDetails;
